import {
    useRef
} from 'react';

import { SimpleGrid, Text } from '@mantine/core';

import { useSubscriptionItems } from '../hooks/useSubscriptionItems.ts';
import { useSubscriptionItemsSelection } from '../hooks/useSubscriptionItemsSelection.ts';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import { DataTableColumn } from "mantine-datatable";
import { DataTableTokenPagination } from "../../../components/DataTableTokenPagination.tsx";
import { SubscriptionItem } from '../types';

interface RecordsTableProps {
    subscriptionId?: string;
}

export const RecordsTable = ({ subscriptionId }: RecordsTableProps) => {

    const {
        items,
        totalCount,
        loading,
        nextToken,
        loadMoreRecords,
        handleFilterByKeyword
    } = useSubscriptionItems(subscriptionId || '');

    const { selectedRecords, setSelectedRecords } = useSubscriptionItemsSelection();



    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const columns: DataTableColumn<SubscriptionItem>[] = [
        {
            accessor: 'price',
            title: 'Product',
            render: (record: SubscriptionItem) => (
                <Text size="sm">
                    {record.price?.product?.name || `Price ID: ${record.priceId}`}
                </Text>
            )
        },
        { 
            accessor: 'quantity', 
            title: 'Quantity',
            render: (record: SubscriptionItem) => (
                <Text size="sm">
                    {record.quantity} {record.price?.billingPeriod ? `/ ${record.price.billingPeriod}` : ''}
                </Text>
            )
        },
        {
            accessor: 'price.amount',
            title: 'Amount',
            render: (record: SubscriptionItem) => (
                <Text size="sm">
                    {record.price?.amount ? `$${(record.price.amount / 100).toFixed(2)}` : 'N/A'}
                </Text>
            )
        },
        { accessor: 'created', title: 'Created' },
    ];

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword} />

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => loadMoreRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken} handleLoadMore={loadMoreRecords} />

        </SimpleGrid>
    );
};